import { useEffect, useState } from 'react';
import { attMatrix, closeAttMonth, deleteAttClose, dayAdjust } from '../api/attendance';

// Tiền phạt mỗi lần đi muộn / về sớm — PHẢI khớp PENALTY_PER_TIME ở backend (utils/attendanceRules.js).
const PENALTY_PER_TIME = 50000;

const ST = {
  work: ['color-mix(in srgb, var(--ok) 15%, transparent)', 'color-mix(in srgb, var(--ok) 45%, transparent)'],
  warn: ['color-mix(in srgb, var(--warn-fill) 18%, transparent)', 'color-mix(in srgb, var(--warn-fill) 50%, transparent)'],
  absent: ['color-mix(in srgb, var(--danger) 12%, transparent)', 'color-mix(in srgb, var(--danger) 40%, transparent)'],
  half: ['color-mix(in srgb, var(--ok) 15%, transparent)', 'color-mix(in srgb, var(--ok) 45%, transparent)'],
  off: ['var(--panel2)', 'var(--border)'],
};
// Ô nửa công (1/2 công): nửa trên-trái tô xanh lá, gạch chéo rõ ở giữa, nửa còn lại để trống.
const HALF_BG = 'linear-gradient(135deg, color-mix(in srgb, var(--ok) 42%, transparent) 0 calc(50% - 0.9px), var(--ok) calc(50% - 0.9px) calc(50% + 0.9px), transparent calc(50% + 0.9px) 100%)';
const str = (v) => (v === 0 || v ? String(v) : '');

// Nhãn 3 LỖI PHẠT riêng biệt (50k/lỗi) — khớp backend: đi muộn / về sớm / quên chấm (vào hoặc ra).
const VIOLS = [['late', '⏰ Đi muộn'], ['early', '🏃 Về sớm'], ['miss', '📵 Quên chấm công']];

// Modal xác nhận lại 1 ngày có đơn giải trình.
function ReviewDay({ emp, dayNum, month, day, proposal, onClose, onAct, lateMax = 3 }) {
  const date = `${month}-${String(dayNum).padStart(2, '0')}`;
  const phat = day?.phat || 0;
  const lateExempt = day?.lateExempt || 0; // >0: ngày CÓ đi muộn nhưng được MIỄN (là lần muộn thứ mấy trong tháng)
  return (
    <div>
      <h3 style={{ marginTop: 0 }}>🔎 Xác nhận ngày {String(dayNum).padStart(2, '0')}/{month.slice(5, 7)} — {emp.name}</h3>
      {proposal ? (
        <div className="card" style={{ background: 'var(--panel2)', margin: '0 0 12px' }}>
          <div><b style={{ color: 'var(--accent)' }}>{proposal.typeLabel}</b> <span className={`chip ${proposal.status === 'approved' ? 'done' : proposal.status === 'rejected' ? '' : 'todo'}`} style={{ fontSize: 11 }}>{proposal.status === 'approved' ? 'Đã duyệt' : proposal.status === 'rejected' ? 'Từ chối' : 'Chờ duyệt'}</span></div>
          {proposal.reason && <div className="small" style={{ marginTop: 4 }}>Lý do: {proposal.reason}</div>}
        </div>
      ) : <div className="small muted" style={{ marginBottom: 12 }}>Ngày này chưa có đơn giải trình.</div>}
      <div className="small muted" style={{ marginBottom: 6 }}>Chấm: {day?.checkCount ? `${day.checkIn}–${day.checkOut}` : 'không có'} · công hiện tại: <b>{day?.cong ?? 0}</b></div>
      {/* 3 LỖI RIÊNG BIỆT của ngày — bỏ / khôi phục TỪNG lỗi (khôi phục chỉ ăn khi lỗi gốc có thật). */}
      <div className="small muted" style={{ marginBottom: 4 }}>
        Lỗi ngày này: {phat > 0
          ? <b style={{ color: 'var(--danger)' }}>{phat} lỗi × {PENALTY_PER_TIME.toLocaleString('vi-VN')}đ = −{(phat * PENALTY_PER_TIME).toLocaleString('vi-VN')}đ</b>
          : <b style={{ color: 'var(--ok)' }}>không có</b>}
        {lateExempt > 0 && <div style={{ color: 'var(--accent)', fontWeight: 600, marginTop: 3 }}>⏰ Có đi muộn nhưng ĐƯỢC MIỄN (lần {lateExempt}/{lateMax} trong tháng) — không phạt.</div>}
      </div>
      <div className="row" style={{ gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
        {VIOLS.map(([k, label]) => {
          // Đi muộn được miễn: hiện chip thông tin (không phạt), không phải nút bỏ/khôi phục.
          if (k === 'late' && lateExempt > 0) {
            return <span key={k} className="btn sm ghost" style={{ color: 'var(--accent)', cursor: 'default' }}
              title={`Đi muộn nhưng nằm trong ${lateMax} lần miễn đầu tháng — không tính phạt`}>{label} · miễn {lateExempt}/{lateMax}</span>;
          }
          const on = !!day?.viol?.[k];
          return (
            <button key={k} className={'btn sm ghost' + (on ? ' danger' : '')}
              style={on ? undefined : { opacity: 0.55 }}
              title={on ? `Đang tính lỗi này (50.000đ) — bấm để BỎ lỗi` : 'Không tính / đã bỏ — bấm để khôi phục nếu lỗi gốc có thật'}
              onClick={() => onAct(date, 'waive-' + k)}>
              {label} {on ? '✕ bỏ' : '↻'}
            </button>
          );
        })}
      </div>
      <div className="small muted" style={{ marginBottom: 10 }}>Kế toán chốt lại cho ngày này:</div>
      <div className="row" style={{ gap: 8, flexWrap: 'wrap' }}>
        <button className="btn sm" onClick={() => onAct(date, 'full')}
          title="Xác nhận đủ 1 công, KHÔNG thêm phạt (giữ nguyên lỗi muộn/sớm nếu có). Ngày này sẽ vào cột Đi làm.">✓ Tính đủ công</button>
        <button className="btn sm ghost" onClick={() => onAct(date, 'half')}>½ Tính 1/2 công</button>
        <button className="btn sm ghost danger" onClick={() => onAct(date, 'none')}>✕ Không tính công</button>
        <button className="btn sm ghost" onClick={() => onAct(date, 'nopenalty')} title="Xoá cả 3 lỗi của ngày, công giữ nguyên">Bỏ hết lỗi (giữ công)</button>
      </div>
      <div className="row" style={{ justifyContent: 'flex-end', marginTop: 14 }}>
        <button className="btn ghost" onClick={onClose}>Đóng</button>
      </div>
    </div>
  );
}

export default function AttendanceMatrix({ month, refreshKey, toast, openModal, closeModal, locked, onPickEmp }) {
  const [data, setData] = useState({ employees: [], standard: 0 });
  const [loading, setLoading] = useState(true);
  const [edits, setEdits] = useState({}); // userId -> {tongNgayCong,diLam,nghi,biPhat}
  const [editMode, setEditMode] = useState(false); // bật/tắt sửa 4 cột tổng kết (kế toán/GĐ)

  const load = () => {
    setLoading(true);
    attMatrix(month).then((d) => {
      setData(d);
      const e = {};
      // Giữ ở dạng CHUỖI để gõ được số lẻ (".5", "0,5") mà không sinh NaN; đổi sang số khi lưu.
      // Có bản chốt (override cố ý qua nút Chỉnh sửa) -> hiện số chốt; chưa có -> số TỰ ĐỘNG live.
      d.employees.forEach((emp) => { const v = emp.closed || emp.stats; e[emp.id] = { tongNgayCong: str(v.tongNgayCong), diLam: str(v.diLam), nghi: str(v.nghi), biPhat: str(v.biPhat) }; });
      setEdits(e);
    }).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(load, [month, refreshKey]); // eslint-disable-line

  // Chỉ cho nhập số, dấu chấm/phẩy thập phân; lưu nguyên chuỗi để không mất "." đang gõ.
  const setCell = (uid, key, val) => setEdits((e) => ({ ...e, [uid]: { ...e[uid], [key]: val.replace(/[^0-9.,]/g, '') } }));
  const toNum = (v) => Number(String(v ?? '').replace(',', '.').trim()) || 0;
  async function saveClose(uid) {
    const p = edits[uid] || {};
    try {
      await closeAttMonth({ userId: uid, month, tongNgayCong: toNum(p.tongNgayCong), diLam: toNum(p.diLam), nghi: toNum(p.nghi), biPhat: toNum(p.biPhat) });
      toast('Đã chốt số của nhân viên');
    } catch (e) { toast(e.response?.data?.message || 'Lỗi chốt', 'danger'); }
  }
  async function resetClose(uid) {
    try {
      await deleteAttClose(uid, month);
      toast('Đã bỏ số chỉnh tay — quay về số tự động');
      load();
    } catch (e) { toast(e.response?.data?.message || 'Lỗi', 'danger'); }
  }
  function clickDay(emp, n) {
    const day = emp.days[n];
    const proposal = emp.proposals[n];
    if (!proposal && !day) return; // ô trống -> bỏ qua
    if (locked) { toast('Tháng đã chốt — không thể sửa. Cần Giám đốc mở khoá.', 'danger'); return; }
    if (!editMode) { toast('Bấm "✏️ Sửa bảng" để chỉnh sửa', 'warn'); return; }
    openModal(<ReviewDay emp={emp} dayNum={n} month={month} day={day} proposal={proposal} lateMax={data.lateExemptMax || 3}
      onClose={closeModal} onAct={async (date, action) => {
        try {
          const r = await dayAdjust(emp.id, date, action);
          // GIỮ NGUYÊN bảng — chỉ PATCH đúng hàng NV này bằng days/stats server vừa tính lại
          // (gồm cả cascade "miễn 3 lần muộn" của riêng NV đó). Không gọi load() -> khỏi tải cả bảng.
          if (r?.days && r?.stats) {
            setData((d) => ({ ...d, employees: d.employees.map((e) => (e.id === emp.id ? { ...e, days: r.days, stats: r.stats } : e)) }));
            const src = emp.closed || r.stats; // có bản chốt -> giữ; chưa -> theo số vừa tính lại
            setEdits((prev) => ({ ...prev, [emp.id]: { tongNgayCong: str(src.tongNgayCong), diLam: str(src.diLam), nghi: str(src.nghi), biPhat: str(src.biPhat) } }));
          }
          toast('Đã xác nhận lại ngày');
          closeModal();
        } catch (e) { toast(e.response?.data?.message || 'Lỗi', 'danger'); }
      }} />);
  }

  // Để tô ĐỎ ngày LÀM đã QUA mà NV không có bản ghi chấm công (nghỉ/quên chấm).
  const [my, mm] = (data.month || '').split('-').map(Number);
  const dim = (my && mm) ? new Date(my, mm, 0).getDate() : 31; // số ngày trong tháng
  const todayStr = new Date().toISOString().slice(0, 10);
  const nameStyle = { position: 'sticky', left: 0, zIndex: 2, background: 'var(--panel)', borderRight: '1px solid var(--border)' };
  // Ghim 2 hàng tiêu đề (số ngày + Thứ) khi cuộn dọc trong bảng. H1 = chiều cao hàng số ngày.
  const H1 = 30;
  const topRow1 = { position: 'sticky', top: 0, zIndex: 3, background: 'var(--panel)' };
  const topRow2 = { position: 'sticky', top: H1, zIndex: 3, background: 'var(--panel)' };
  const corner1 = { ...nameStyle, top: 0, zIndex: 5 }; // ô góc dính cả trái lẫn trên
  const corner2 = { ...nameStyle, top: H1, zIndex: 5 };
  const SUM = [['tongNgayCong', 'Tổng công'], ['diLam', 'Đi làm'], ['nghi', 'Nghỉ'], ['biPhat', 'Phạt']];

  return (
    <div className="card">
      <div className="row between" style={{ marginBottom: 10, flexWrap: 'wrap', gap: 8 }}>
        <h3 style={{ margin: 0 }}>🗓️ Bảng chấm công toàn phòng ({data.employees.length})</h3>
        <div className="row" style={{ gap: 10, alignItems: 'center' }}>
          <span className="small muted">
            {editMode ? 'Đang SỬA: bấm ô ngày để xác nhận · sửa 4 cột tổng kết' : 'Chế độ xem · chuẩn: ' + data.standard + ' công'}
          </span>
          {!locked && (
            <button className={`btn sm ${editMode ? '' : 'ghost'}`} onClick={() => setEditMode((v) => !v)}
              title="Bật/tắt chỉnh sửa bảng (ô ngày + 4 cột tổng kết). Tắt = chỉ xem.">
              {editMode ? '✓ Xong' : '✏️ Sửa bảng'}
            </button>
          )}
        </div>
      </div>
      {loading ? <div className="empty">Đang tải…</div> : !data.employees.length ? <div className="empty">Chưa có dữ liệu.</div> : (
        <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: 'calc(100vh - 240px)' }}>
          <table style={{ borderCollapse: 'separate', borderSpacing: 0, fontSize: 12, whiteSpace: 'nowrap' }}>
            <thead>
              <tr>
                <th style={{ ...corner1, padding: '6px 10px', textAlign: 'left', minWidth: 130, color: 'var(--muted)' }}>Nhân viên</th>
                {Array.from({ length: 31 }, (_, i) => <th key={i} className="only-desktop" style={{ ...topRow1, width: 32, padding: '6px 0 2px', textAlign: 'center', color: 'var(--muted2)', fontWeight: 500, fontSize: 13 }}>{i + 1}</th>)}
                {SUM.map(([k, l], i) => <th key={k} rowSpan={2} style={{ ...topRow1, minWidth: 50, padding: '5px 4px', textAlign: 'center', color: 'var(--muted)', borderLeft: i === 0 ? '1px solid var(--border)' : 0, verticalAlign: 'bottom' }}>{l}</th>)}
              </tr>
              <tr>
                <th className="only-desktop" style={{ ...corner2, padding: '0 10px 6px', textAlign: 'left', color: 'var(--faint)', fontWeight: 400, fontSize: 12 }}>Thứ</th>
                {(() => {
                  const [y, mo] = (data.month || '').split('-').map(Number);
                  const dim = y && mo ? new Date(y, mo, 0).getDate() : 31;
                  const WDS = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];
                  return Array.from({ length: 31 }, (_, i) => {
                    const n = i + 1;
                    if (!y || n > dim) return <th key={n} className="only-desktop" style={{ ...topRow2, padding: '0 0 5px' }} />;
                    const wd = new Date(y, mo - 1, n).getDay();
                    return <th key={n} className="only-desktop" style={{ ...topRow2, padding: '0 0 6px', textAlign: 'center', fontSize: 12, fontWeight: 600, color: wd === 0 ? 'var(--danger)' : wd === 6 ? 'var(--warn)' : 'var(--faint)' }}>{WDS[wd]}</th>;
                  });
                })()}
              </tr>
            </thead>
            <tbody>
              {(() => {
                const out = []; let curDept = null;
                data.employees.forEach((emp) => {
                  if (emp.dept !== curDept) {
                    curDept = emp.dept;
                    out.push(
                      <tr key={`dept-${curDept}`}>
                        <td colSpan={36} style={{ padding: 0, background: 'var(--band2)', borderTop: '2px solid var(--border)' }}>
                          <div style={{ position: 'sticky', left: 0, padding: '5px 12px', fontWeight: 700, fontSize: 12, color: 'var(--text2)', display: 'inline-block' }}>{curDept}</div>
                        </td>
                      </tr>
                    );
                  }
                  out.push(
                    <tr key={emp.id} style={{ borderTop: '1px solid var(--line)' }}>
                      <td style={{ ...nameStyle, padding: '8px 12px', fontWeight: 600, fontSize: 13 }}>
                        <span onClick={onPickEmp ? () => onPickEmp(emp.id) : undefined}
                          style={onPickEmp ? { cursor: 'pointer', color: 'var(--accent)' } : undefined}
                          title={onPickEmp ? 'Xem lịch chấm công chi tiết của người này' : undefined}>{emp.name}</span>{emp.team ? <span className="small muted" style={{ fontSize: 12 }}> · {emp.team}</span> : emp.role === 'TP' ? <span className="small muted" style={{ fontSize: 12 }}> · TP</span> : ''}</td>
                  {Array.from({ length: 31 }, (_, i) => {
                    const n = i + 1; const d = emp.days[n]; const p = emp.proposals[n];
                    // MÀU Ô theo 4 quy tắc: CÓ LỖI (phạt>0) -> VÀNG; không lỗi + nửa công (0.5, gồm
                    // chấm 1 lần) -> ½ XANH; còn lại theo trạng thái (đủ công xanh / nghỉ đỏ / CN-T7 xám).
                    const hasPen = d && (d.phat || 0) > 0;
                    const isHalf = d && d.cong === 0.5 && !hasPen;
                    // Không có bản ghi chấm: nếu là NGÀY LÀM ĐÃ QUA (T2–T6, +T7 với Phòng OP) -> tô ĐỎ
                    // (không chấm công / nghỉ không phép); còn lại (CN, T7 phòng khác, ngày chưa tới) -> trống.
                    let missed = false;
                    if (!d && my && mm && n <= dim) {
                      const wd = new Date(my, mm - 1, n).getDay(); // 0=CN..6=T7
                      const isWorkday = wd >= 1 && (wd <= 5 || (wd === 6 && emp.worksSat));
                      const isPast = `${data.month}-${String(n).padStart(2, '0')}` < todayStr; // trước hôm nay
                      missed = isWorkday && isPast;
                    }
                    const c = !d ? (missed ? ST.absent : ['transparent', 'transparent']) : hasPen ? ST.warn : isHalf ? ST.half : (ST[d.status] || ST.off);
                    const clickable = editMode && !!(d || p); // chỉ sửa ô ngày khi đang ở chế độ Sửa bảng
                    return (
                      <td key={n} className="only-desktop" style={{ padding: '5px 2px', textAlign: 'center' }}>
                        <span onClick={() => clickDay(emp, n)} title={(d?.phat ? `Lỗi: ${VIOLS.filter(([k]) => d.viol?.[k]).map(([, l]) => l).join(', ')} (−${(d.phat * PENALTY_PER_TIME).toLocaleString('vi-VN')}đ). ` : '') + (d?.firstSeenCompany ? `Ở cty (Wifi/IP): ${d.firstSeenCompany}–${d.lastSeenCompany || d.firstSeenCompany}. ` : '') + (d?.awayHours ? `Vắng cty ${d.awayHours}h (${(d.awayLog || []).join(', ')}). ` : '') + (d?.adminAdjusted ? 'Kế toán đã xác nhận' : p ? p.typeLabel : d ? d.status : (missed ? 'Không chấm công (ngày làm đã qua)' : ''))}
                          style={{ display: 'inline-block', width: 28, height: 28, borderRadius: 7, background: isHalf ? HALF_BG : c[0], border: `1px solid ${c[1]}`, cursor: clickable ? 'pointer' : 'default', position: 'relative', boxShadow: d?.adminAdjusted ? '0 0 0 1.5px var(--ok) inset' : d?.approved ? '0 0 0 1.5px var(--danger) inset' : 'none' }}>
                          {d?.adminAdjusted ? <span style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, fontWeight: 800, color: 'var(--ok)', lineHeight: 1 }}>✓</span>
                            : p ? <span style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: 12, height: 12, borderRadius: '50%', background: 'var(--danger)' }} /> : null}
                          {d?.awayHours > 0 && <span title={`Vắng cty ${d.awayHours}h`} style={{ position: 'absolute', bottom: -2, right: -2, fontSize: 9, fontWeight: 800, color: 'var(--warn)', background: 'var(--panel)', borderRadius: 4, lineHeight: 1, padding: '0 1px' }}>{d.awayHours}h</span>}
                        </span>
                      </td>
                    );
                  })}
                  {SUM.map(([k], i) => (
                    <td key={k} style={{ padding: '5px 4px', textAlign: 'center', borderLeft: i === 0 ? '1px solid var(--border)' : 0 }}>
                      {editMode && !locked ? (
                        <input type="text" inputMode="decimal" value={edits[emp.id]?.[k] ?? ''} onChange={(e) => setCell(emp.id, k, e.target.value)} onBlur={() => saveClose(emp.id)}
                          style={{ width: 42, height: 28, textAlign: 'center', fontSize: 13, padding: 0, color: k === 'nghi' ? 'var(--danger)' : k === 'biPhat' ? 'var(--warn)' : undefined, background: 'color-mix(in srgb, var(--warn) 12%, transparent)' }} />
                      ) : (
                        <span title={emp.closed ? 'Số đã chỉnh tay' : 'Số tự động'}
                          style={{ display: 'inline-block', minWidth: 42, height: 28, lineHeight: '28px', fontSize: 13, fontWeight: emp.closed ? 700 : 400, color: k === 'nghi' ? 'var(--danger)' : k === 'biPhat' ? 'var(--warn)' : 'var(--text)', background: emp.closed ? 'color-mix(in srgb, var(--accent) 8%, transparent)' : undefined, borderRadius: 6 }}>
                          {edits[emp.id]?.[k] ?? ''}
                        </span>
                      )}
                      {/* TIỀN PHẠT = số LỖI × 50.000đ (đi muộn / về sớm / quên chấm — 3 lỗi riêng). */}
                      {k === 'biPhat' && Number(edits[emp.id]?.biPhat) > 0 && (
                        <div style={{ fontSize: 9.5, fontWeight: 700, color: 'var(--danger)', marginTop: 1, whiteSpace: 'nowrap' }}
                          title={`${edits[emp.id].biPhat} lỗi × ${PENALTY_PER_TIME.toLocaleString('vi-VN')}đ (muộn / về sớm / quên chấm)`}>
                          −{(Number(edits[emp.id].biPhat) * PENALTY_PER_TIME).toLocaleString('vi-VN')}đ
                        </div>
                      )}
                      {/* Khi đang sửa: cho phép bỏ số chỉnh tay -> quay về số tự động. */}
                      {k === 'biPhat' && editMode && !locked && emp.closed && (
                        <div style={{ marginTop: 2 }}>
                          <button className="btn xs ghost" style={{ fontSize: 10, padding: '1px 5px' }} onClick={() => resetClose(emp.id)}
                            title="Xoá số chỉnh tay, quay về số tự động">↺ tự động</button>
                        </div>
                      )}
                    </td>
                  ))}
                    </tr>
                  );
                });
                return out;
              })()}
            </tbody>
          </table>
        </div>
      )}
      <div className="row" style={{ gap: 14, flexWrap: 'wrap', marginTop: 10, fontSize: 12, color: 'var(--muted)' }}>
        <span><i style={{ color: 'var(--ok)' }}>■</i> đi làm</span>
        <span><i style={{ color: 'var(--warn-fill)' }}>■</i> muộn/thiếu</span>
        <span><i style={{ display: 'inline-block', width: 11, height: 11, borderRadius: 3, verticalAlign: '-1px', background: HALF_BG, border: '1px solid color-mix(in srgb, var(--ok) 45%, transparent)' }} /> 1/2 công (1 buổi)</span>
        <span><i style={{ color: 'var(--danger)' }}>■</i> nghỉ</span>
        <span><i style={{ color: 'var(--muted2)' }}>■</i> CN/T7 ĐK</span>
        <span><i style={{ color: 'var(--danger)' }}>●</i> có đơn giải trình (bấm để xác nhận)</span>
        <span><b style={{ color: 'var(--ok)' }}>✓</b> kế toán đã xác nhận</span>
        <span>ô nền chàm = đã chốt số</span>
      </div>
    </div>
  );
}
